// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__ITvdQ","toggle":"styles_toggle__i5lee","disabled":"styles_disabled__RJdPl"};